import React from "react";
import { IconProps } from "../icon";

export const CurrencyDollarIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 16a4 4 0 004 4h4a4 4 0 000-8h-4a4 4 0 010-8h4a4 4 0 014 4m-6-6v20"
    />
  </svg>
);
